import { render, staticRenderFns } from "./EditH1GoodsItems.vue?vue&type=template&id=645846d5&scoped=true&"
import script from "./EditH1GoodsItems.vue?vue&type=script&lang=js&"
export * from "./EditH1GoodsItems.vue?vue&type=script&lang=js&"
import style0 from "./EditH1GoodsItems.vue?vue&type=style&index=0&id=645846d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645846d5",
  null
  
)

export default component.exports